module.exports = __webpack_public_path__ + "img/super-mario.3743cf31.png";